export enum LoadingStatus {
    Failed = -1,
    Loading = 1,
    Success
}
